import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// styles
// bootstrap
import { Container } from 'react-bootstrap';
// icons : feather
import FeatherIcon from 'feather-icons-react';

// unique id
import uuid from 'react-uuid'

// drag and drop
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// react toastify
import { toast } from 'react-toastify';

// common healpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'

import InfoModal from 'utlis/helpers/Modals/InfoModal'

function AddVariation(props) {
    // props
    const {
        formik,

        handleVariantPageHide,

        productCombinations,
        variantMainFields,

        handleAddNewProductCombinations,

        variantAllFieldsData,
        setVariantAllFieldsData,

        setDeletedVariantMainFields,
        deletedVariantMainFields,

        deletedproductCombinations,
        setDeletedProductCombinations,
    } = props

    // consts
    const EMPTY_FIELDS_ERROR_MESSAGE = "Please fill all the required fields"
    const FIELD_REQUIRED_VALIDATION_MESSAGE = "This field is required"
    const SAME_FIELD_VALIDATION_MESSAGE = "The same option name already exists"
    const DELETING_VARIANT_COMBINATION_CONFIRM_MESSAGE = "This value is used in the variants created earlier! are you sure you want to delete this item? all your combinations will get created from starting"

    const addVariantField = {
        variation_id: uuid(),
        variation_name: '',
        display_type: 'rectangle_list',
        is_field_touched: false,
        has_field_error: false,
        error_msg: '',
        options: [{
            option_variation_name: '',
            id: uuid(),
            value: '',
            is_default: false,
            is_field_touched: false,
            has_field_error: false,
            error_msg: '',
        }]
    }
    const addVariantValueField = {
        option_variation_name: '',
        id: uuid(),
        value: '',
        is_default: false,
        is_field_touched: false,
        has_field_error: false,
        error_msg: '',
    }

    // states
    const [isNewVariantOption, setisNewVariantOption] = useState(false)
    const [shouldCreateCombinationsFromStarting, setShouldCreateCombinationsFromStarting] = useState(false)

    const [hasPageContentChanged, setHasPageContentChanged] = useState(false)

    const [leavethePageModalVisibility, setLeavethePageModalVisibility] = useState(false)
    const [changingTheVariantModalVisibility, setChangingTheVariantModalVisibility] = useState(false)


    // to change the page content changed to true
    function pageContentChanged() {
        if (!hasPageContentChanged) {
            setHasPageContentChanged(true)
        }
    }

    // leave page modal hide
    const onLeavePageModalHide = () => {
        setLeavethePageModalVisibility(false)
    }

    // user leaving modal result
    function confirmPageLeaveAction(bool) {
        // if user selects cancel to leave the page
        if (bool) {
            setLeavethePageModalVisibility(false)
        } else {
            setTimeout(() => {
                // send to user back to variant page
                handleVariantPageHide && handleVariantPageHide()
            }, 200);
        }
    }

    // chaning the variant modal hide
    const onConfirmChangingVariantModalHide = () => {
        setChangingTheVariantModalVisibility(false)
    }

    // user chaning the data modal result
    function confirmChangingVariantAction(bool) {
        // if user selects cancel to leave the page
        if (bool) {
            // IF THE USER SELECTS TO NOT CHANGE CHANGE THE VARIANT
            const oldVariants = variantMainFields

            // setting old data 
            setVariantAllFieldsData(oldVariants)

            // closing the modal
            setChangingTheVariantModalVisibility(false)

            // go back to product page
            handleVariantPageHide && handleVariantPageHide()
        } else {
            // IF THE USER SELECTS TO CHANGE CHANGE THE VARIANT
            let newCombinationsObject = []

            // generating combinations data needed to generate combinations array
            const options = variantAllFieldsData.map(item => item.options);
            const combinations = getCombinations(options)

            // generating new combinations array
            for (const combiItem of combinations) {
                // combinations variable
                let variation_combination = combiItem.map(item => item)

                // variant variable
                let variant = combiItem.map(item => item.option_variation_name + ": " + item.value).toString().replace(/,/g, ", ")

                // sku variable
                let sku = formik.getFieldProps("SKU").value + "-" + combiItem.map((item, index) => {
                    let alteredValue = ""
                    alteredValue = `${item.value}${(combiItem[index] !== combiItem[combiItem.length - 1]) ? "-" : ""}`
                    return alteredValue
                }).toString().replace(/,/g, "")

                newCombinationsObject.push({
                    id: uuid(),
                    status: true,
                    variation_image: null,
                    variant,
                    sku,
                    weight: "",
                    cost: "",
                    price: "",
                    stock: "",
                    length: "",
                    width: "",
                    height: "",
                    upc: "",
                    description: "",
                    variation_combination,
                })
            }

            // saving variant and combinations values
            handleAddNewProductCombinations(
                newCombinationsObject,
                variantAllFieldsData
            )

            // setting deleted variants | if deleted variants are not already existed
            if ((!deletedVariantMainFields?.length) && (!deletedproductCombinations?.length)) {
                setDeletedVariantMainFields(variantMainFields)
                setDeletedProductCombinations(productCombinations)
                console.log("set successfull!!");
            }

            // go back to product page
            handleVariantPageHide && handleVariantPageHide()

        }
    }

    // checking existing variants data
    useEffect(() => {
        if (!variantMainFields?.length) {
            setVariantAllFieldsData([addVariantField])
        } else {
            setVariantAllFieldsData(variantMainFields)
        }
    }, [])

    // add new variant
    const handleAddVariant = ev => {
        ev.preventDefault()

        // change the page content changed to true
        pageContentChanged()

        // new element to be added
        const newElement = addVariantField

        // adding new variant to the state array
        setVariantAllFieldsData([...variantAllFieldsData, newElement])
    }

    // add new value to variant options
    const handleAddVariantValue = (ev, variantIndex) => {
        ev.preventDefault()
        // change the page content changed to true
        pageContentChanged()

        // new element to be added
        const newElement = addVariantValueField

        // finding the item from the main variant
        const itemToBeChanged = variantAllFieldsData[variantIndex]

        // if item exists
        if (itemToBeChanged) {
            // adding new element to the array
            itemToBeChanged.options.push(newElement)

            // adding updated element to the main state array
            const filteredList = [...variantAllFieldsData.slice(0, variantIndex), itemToBeChanged, ...variantAllFieldsData.slice(variantIndex + 1)]

            // updating the main variant state array
            setVariantAllFieldsData(filteredList)
        }
    }

    // delete variant
    const handleDeleteVariant = (ev, variantId) => {
        ev.preventDefault()

        if (variantId) {
            // change the page content changed to true
            pageContentChanged()

            // generating array that does not contain the item to be removed
            const updatedVariantsFields = variantAllFieldsData.filter(item => item.variation_id !== variantId)

            // adding data to the variant state
            setVariantAllFieldsData(updatedVariantsFields)
        }
    }

    const checkVariationCombinationExistenceByName = (parentName, name) => {
        if (parentName && name) {
            let shouldAllow = false
            // checking if combinations are already created
            if (productCombinations?.length) {
                const variantsNames = productCombinations.map(item => item.variant).toString()
                if (variantsNames.includes(parentName + ": " + name)) {
                    shouldAllow = false
                } else {
                    shouldAllow = true
                }
            } else {
                shouldAllow = true
            }
            return shouldAllow
        }
        return false
    }

    // delete variant value
    const handleDeleteVariantValue = (ev, variantIndex, variantId, variantValueId, variantParentOptionName, variantValueName) => {
        ev.preventDefault()

        if (variantValueId) {
            // change the page content changed to true
            pageContentChanged()

            // deleting item function
            function deleteConfirm() {
                // getting values for which the value needs to be delete
                const valuesArray = variantAllFieldsData.filter(item => item.variation_id === variantId)

                // if values array exists
                if (valuesArray?.length) {
                    // removing the required value from the values array
                    let allValues = valuesArray[0].options.filter(item => item.id !== variantValueId)

                    // main value item after changes
                    valuesArray[0].options = allValues

                    // finding array in the main variant value
                    const updatedVariantsFields = [
                        ...variantAllFieldsData.slice(0, variantIndex),
                        valuesArray[0],
                        ...variantAllFieldsData.slice(variantIndex + 1)
                    ]

                    // adding data to the variant state
                    setVariantAllFieldsData(updatedVariantsFields)
                }
            }
            deleteConfirm()
            // // checking if any variant combination is created using this name
            // if (checkVariationCombinationExistenceByName(variantParentOptionName, variantValueName)) {
            // } else {
            //     const confirmation = window.confirm(DELETING_VARIANT_COMBINATION_CONFIRM_MESSAGE)
            //     if (confirmation) {
            //         // setting confirmation that the variations will get created from the starting
            //         setShouldCreateCombinationsFromStarting(true)

            //         deleteConfirm()
            //     }
            // }

        }
    }

    // same name tester for the name variant
    const sameNameTester = debounce((indexValue, nameValue) => {
        if (nameValue) {
            // copy of the variant main fields array
            const COPY_variantAllFieldsFields = variantAllFieldsData
            let alreadyfound = false

            // looping
            COPY_variantAllFieldsFields.forEach((variantItem, variantItemIndex) => {
                // validate same name except the current index
                if (variantItemIndex !== indexValue && variantItem.variation_name === nameValue) {
                    alreadyfound = true
                }
            })

            // if same field exists then showing the error
            if (alreadyfound) {
                // changing error status
                COPY_variantAllFieldsFields[indexValue].has_field_error = true
                COPY_variantAllFieldsFields[indexValue].error_msg = SAME_FIELD_VALIDATION_MESSAGE
            } else {
                // changing error status
                COPY_variantAllFieldsFields[indexValue].has_field_error = false
                COPY_variantAllFieldsFields[indexValue].error_msg = ""
            }

            // adding field
            setVariantAllFieldsData([...COPY_variantAllFieldsFields])
        }
    }, 500)

    // when name value changes
    const handleNameChange = (ev, variantIndex) => {
        // change the page content changed to true
        pageContentChanged()

        const inputValue = ev.target.value

        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // checking if the option name is same as already used
        sameNameTester(variantIndex, inputValue)

        // adding class to parent based on the value
        if (inputValue === "") {
            // changing error status
            COPY_variantAllFieldsFields[variantIndex].has_field_error = true
            COPY_variantAllFieldsFields[variantIndex].error_msg = FIELD_REQUIRED_VALIDATION_MESSAGE
        } else {
            // changing error status
            COPY_variantAllFieldsFields[variantIndex].has_field_error = false
            COPY_variantAllFieldsFields[variantIndex].error_msg = ""
        }

        // changing name value
        COPY_variantAllFieldsFields[variantIndex]['variation_name'] = inputValue
        // adding name to the option for parent reference
        COPY_variantAllFieldsFields[variantIndex].options.map(item => ({
            ...item,
            option_variation_name: inputValue
        }))

        // adding field
        setVariantAllFieldsData([...COPY_variantAllFieldsFields])
    }
    // when name is focused
    const handleNameFocus = (ev, variantIndex) => {
        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // changing touched value
        COPY_variantAllFieldsFields[variantIndex].is_field_touched = true

        // updating main fields data array
        setVariantAllFieldsData([...COPY_variantAllFieldsFields])
    }

    // when name is blurred
    const handleNameBlur = (ev, variantIndex) => {
        const inputValue = ev.target.value

        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // adding class to parent based on the value
        if (inputValue === "") {
            // changing error status
            COPY_variantAllFieldsFields[variantIndex].has_field_error = true
            COPY_variantAllFieldsFields[variantIndex].error_msg = FIELD_REQUIRED_VALIDATION_MESSAGE
        } else {
            // if there's no other error already exists
            if (!COPY_variantAllFieldsFields[variantIndex].has_field_error) {
                // changing error status
                COPY_variantAllFieldsFields[variantIndex].has_field_error = false
                COPY_variantAllFieldsFields[variantIndex].error_msg = ""
            }
        }

        // updating main fields data array
        setVariantAllFieldsData([...COPY_variantAllFieldsFields])
    }

    // when option value changes
    const handleOptionChange = (ev, variantIndex) => {
        // change the page content changed to true
        pageContentChanged()

        const inputValue = ev.target.value

        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // changing name value
        COPY_variantAllFieldsFields[variantIndex]['display_type'] = inputValue

        // adding field
        setVariantAllFieldsData([...COPY_variantAllFieldsFields])
    }

    // same name tester for the name variant
    const sameOptionValueTester = debounce((parentIndexValue, indexValue, nameValue) => {
        if (nameValue) {
            // copy of the variant main fields array
            const COPY_variantAllFieldsFields = variantAllFieldsData
            let alreadyfound = false

            // looping
            COPY_variantAllFieldsFields.forEach((variantItem, variantItemIndex) => {
                // checking validation on a particular option
                if (variantItemIndex === parentIndexValue) {
                    // looping over options
                    variantItem.options.forEach((optionItem, optionItemIndex) => {
                        // validate same value except the current index
                        if (optionItemIndex !== indexValue && optionItem.value === nameValue) {
                            alreadyfound = true
                        }
                    })
                }
            })

            // if same field exists then showing the error
            if (alreadyfound) {
                // changing error status
                COPY_variantAllFieldsFields[parentIndexValue].options[indexValue].has_field_error = true
                COPY_variantAllFieldsFields[parentIndexValue].options[indexValue].error_msg = SAME_FIELD_VALIDATION_MESSAGE
            } else {
                // changing error status
                COPY_variantAllFieldsFields[parentIndexValue].options[indexValue].has_field_error = false
                COPY_variantAllFieldsFields[parentIndexValue].options[indexValue].error_msg = ''
            }

            // adding field
            setVariantAllFieldsData([...COPY_variantAllFieldsFields])
        }
    }, 500)

    // when value changes
    const handleValueChange = (ev, variantIndex, variantValueIndex) => {
        // change the page content changed to true
        pageContentChanged()

        const inputValue = ev.target.value

        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // checking if the option value is same as already used
        sameOptionValueTester(variantIndex, variantValueIndex, inputValue)

        // adding class to parent based on the value
        if (inputValue === "") {
            // changing error status
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].has_field_error = true
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].error_msg = FIELD_REQUIRED_VALIDATION_MESSAGE
        } else {
            // changing error status
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].has_field_error = false
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].error_msg = ""
        }

        const variation_name = COPY_variantAllFieldsFields[variantIndex].variation_name
        // changing name value
        COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex]['value'] = inputValue
        COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex]['option_variation_name'] = variation_name

        // adding field
        setVariantAllFieldsData([...COPY_variantAllFieldsFields])
    }

    // when value is focused
    const handleValueFocus = (ev, variantIndex, variantValueIndex) => {
        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // changing touched value
        COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].is_field_touched = true

        // updating main fields data array
        setVariantAllFieldsData([...COPY_variantAllFieldsFields])
    }

    // when value is blurred
    const handleValueBlur = (ev, variantIndex, variantValueIndex) => {
        const inputValue = ev.target.value

        // copy of the variant main fields array
        const COPY_variantAllFieldsFields = variantAllFieldsData

        // adding class to parent based on the value
        if (inputValue === "") {
            // changing error status
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].has_field_error = true
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].error_msg = FIELD_REQUIRED_VALIDATION_MESSAGE
        } else {
            // changing error status
            if (!COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].has_field_error) {
                COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].has_field_error = false
                COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex].error_msg = ""
            }
        }
    }

    // when is default changes
    const handleIsDefaultChange = (ev, variantIndex, variantValueIndex) => {
        // change the page content changed to true
        pageContentChanged()

        const inputValue = ev.target.checked

        if (inputValue) {
            // copy of the variant main fields array
            const COPY_variantAllFieldsFields = variantAllFieldsData

            // making other is Default false
            COPY_variantAllFieldsFields[variantIndex].options.forEach((elem, index) => {
                // changing name value
                COPY_variantAllFieldsFields[variantIndex].options[index]['is_default'] = false
            })

            // changing name value
            COPY_variantAllFieldsFields[variantIndex].options[variantValueIndex]['is_default'] = inputValue

            // adding field
            setVariantAllFieldsData([...COPY_variantAllFieldsFields])
        }

    }

    // drag and drop | variant main
    const onVariantDragEnd = result => {
        // change the page content changed to true
        pageContentChanged()

        const { destination, source } = result

        // if there's no destination - means that the user started to drag the object but didn't drop it to any place or dropped it outside the view
        if (!destination) {
            return;
        }

        // checking if the droppable id and index of the destination is same as the source
        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        // main logic
        // getting main variant state array
        const COPY_variantAllFieldsFields = Array.from(variantAllFieldsData)

        // removing item from the copy of the main variant array
        const [removedItem] = COPY_variantAllFieldsFields.splice(source.index, 1)

        // adding item to the copy of the main variant array
        COPY_variantAllFieldsFields.splice(destination.index, 0, removedItem)

        // updaing the main variant state array
        setVariantAllFieldsData(COPY_variantAllFieldsFields)
    }

    // drag and drop | variant options
    const onVariantValueDragEnd = (result, variantIndex) => {
        // change the page content changed to true
        pageContentChanged()

        const { destination, source } = result

        // if there's no destination - means that the user started to drag the object but didn't drop it to any place or dropped it outside the view
        if (!destination) {
            return;
        }

        // checking if the droppable id and index of the destination is same as the source
        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        // main logic
        // getting main variant state array
        const COPY_variantAllFieldsFields = Array.from(variantAllFieldsData)
        const COPY_variantAllFieldsFieldsValues = COPY_variantAllFieldsFields[variantIndex].options

        // removing item from the copy of the main variant array
        const [removedItem] = COPY_variantAllFieldsFieldsValues.splice(source.index, 1)

        // // adding item to the copy of the main variant array
        COPY_variantAllFieldsFieldsValues.splice(destination.index, 0, removedItem)

        // // updaing the main variant state array
        setVariantAllFieldsData(COPY_variantAllFieldsFields)
    }

    // error checker
    const formErrorCheck = () => {
        let isErrorFree = false

        const COPY_variantAllFieldsFields = variantAllFieldsData
        COPY_variantAllFieldsFields.forEach(mainEleItem => {
            // if fields are touched
            if (mainEleItem.is_field_touched) {
                if (mainEleItem.has_field_error) {
                    isErrorFree = false
                    return
                } else {
                    // options
                    mainEleItem.options.forEach(optionEleItem => {
                        if (optionEleItem.is_field_touched) {
                            if (optionEleItem.has_field_error) {
                                isErrorFree = false
                            } else {
                                isErrorFree = true
                            }
                        } else {
                            isErrorFree = false
                            return
                        }
                    })
                }
            } else {
                isErrorFree = false
                return
            }
        })
        return isErrorFree
    }

    // get array combinations
    function getCombinations(args) {
        let mainArray = [], max = args.length - 1;
        function helper(arr, i) {
            for (let j = 0; j < args[i].length; j++) {
                let a = arr.slice(0); // clone arr
                a.push(args[i][j]);
                if (i === max) {
                    mainArray.push(a);
                } else {
                    helper(a, i + 1);
                }
            }
        }
        helper([], 0);
        return mainArray;
    }

    // handle button submission
    const handleFormSubmission = () => {
        if (variantAllFieldsData?.length) {
            // checking of errors
            if (formErrorCheck()) {
                let newCombinationsObject = []
                let combinationsToBeSaved;
                let variantsToBeSaved;
                let isNewOptionAdded = false

                // generating combinations data needed to generate combinations array
                const options = variantAllFieldsData.map(item => item.options);
                const combinations = getCombinations(options)
                // generating new combinations array
                for (const combiItem of combinations) {
                    // combinations variable
                    let variation_combination = combiItem.map(item => item)

                    // variant variable
                    let variant = combiItem.map(item => item.option_variation_name + ": " + item.value).toString().replace(/,/g, ", ")

                    // sku variable
                    let sku = formik.getFieldProps("SKU").value + "-" + combiItem.map((item, index) => {
                        let alteredValue = ""
                        alteredValue = `${item.value}${(combiItem[index] !== combiItem[combiItem.length - 1]) ? "-" : ""}`
                        return alteredValue
                    }).toString().replace(/,/g, "")

                    newCombinationsObject.push({
                        id: uuid(),
                        status: true,
                        variation_image: null,
                        variant,
                        sku,
                        weight: "",
                        cost: "",
                        price: "",
                        stock: "",
                        length: "",
                        width: "",
                        height: "",
                        upc: "",
                        description: "",
                        variation_combination,
                    })
                }

                // CHECKING IF IT IS EXPLICITLY DEFIND THAT CREATE COMBINATINS AND VARIANTS FROM STARTING
                if (shouldCreateCombinationsFromStarting) {
                    combinationsToBeSaved = newCombinationsObject
                    variantsToBeSaved = variantAllFieldsData
                } else {
                    // IF THERE ARE VARIANTS ALREADY GENERATED
                    if (variantMainFields?.length) {
                        // defining if the user added a new variant name or not
                        for (const variAllItem of variantAllFieldsData) {
                            for (const variMainItem of variantMainFields) {
                                // actions for the variant names only
                                if (variAllItem.variation_name !== variMainItem.variation_name) {
                                    isNewOptionAdded = true
                                } else {
                                    isNewOptionAdded = false
                                }
                            }
                        }

                        // setting status that the new variant options is added
                        setisNewVariantOption(isNewOptionAdded)

                        // if no new options is added then saving the normal data
                        if (!isNewOptionAdded) {
                            variantsToBeSaved = variantAllFieldsData
                        }
                    } else {
                        variantsToBeSaved = variantAllFieldsData
                    }

                    // IF THERE ARE SOME COMBINATIONS ALREADY GENERATED
                    if (productCombinations?.length) {
                        // if new option name is not added
                        if (!isNewOptionAdded) {
                            const mergedArray = [
                                ...productCombinations,
                                ...newCombinationsObject
                            ];

                            // generating main array
                            const mainCombinationArray = mergedArray.reduce((acc, item) => {
                                if (!acc.some(e => e.variant === item.variant)) {
                                    acc.push(item);
                                }
                                return acc;
                            }, []);

                            combinationsToBeSaved = mainCombinationArray
                        } else {
                            combinationsToBeSaved = newCombinationsObject
                        }
                    } else {
                        combinationsToBeSaved = newCombinationsObject
                    }
                }

                // if new option name is added
                if (isNewOptionAdded) {
                    // showing confirmation modal if the user really wants to create a new variant
                    setChangingTheVariantModalVisibility(true)
                } else {
                    // saving variant and combinations values
                    handleAddNewProductCombinations(
                        combinationsToBeSaved,
                        variantsToBeSaved
                    )

                    console.log("combinationsToBeSaved ", combinationsToBeSaved);
                    console.log("variantsToBeSaved ", variantsToBeSaved);

                    // go back to product page
                    handleVariantPageHide && handleVariantPageHide()
                }
            } else {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(EMPTY_FIELDS_ERROR_MESSAGE, {
                    autoClose: 2000,
                })
            }
        }

        // onVariantFormSubmit()
    }

    // handle button submission
    const handleBackPress = (ev) => {
        ev.preventDefault()
        if (hasPageContentChanged) {
            setLeavethePageModalVisibility(true)
        } else {
            handleVariantPageHide && handleVariantPageHide()
        }
    }

    return (
        <React.Fragment>
            {/* save button */}
            <div id="page-save-button-block" className={`${variantAllFieldsData?.length ? "component-changed" : ""}`}>
                <Container fluid className="st-container">
                    <div className="page-save-button-block d-flex align-items-center">
                        {/* BACK BUTTON WRAPPER */}
                        <div className="back-button-wrapper st-line-height-0">
                            <a href="/" onClick={handleBackPress} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600">
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="16"
                                    className="icon me-1" />
                                <span>Cancel and back to add product</span>
                            </a>
                        </div>

                        {/* save btn */}
                        <button className="st-btn st-btn-primary ms-auto" onClick={ev => {
                            ev.preventDefault()
                            handleFormSubmission()
                        }}>Save Option</button>
                    </div>
                </Container>
            </div>

            {/* main components */}
            <div id="add-product-variant-view">
                <Container fluid className="st-container">
                    <div className="add-product-variant-view">
                        {/* HEADING WRAPPER */}
                        <div className="app-header-wrapper">
                            {/* heading */}
                            <p className="app-heading text-capitalize">Add Options</p>
                            <p className="app-desc">
                                Add options like size and color for this product
                            </p>
                        </div>

                        {/* page content */}
                        <div className="page-content st-def-pad-B">
                            {/* page border box */}
                            <div className="page-border-box">
                                <div className="pbb-inner">
                                    {/* content */}
                                    <div className="content">
                                        <DragDropContext onDragEnd={onVariantDragEnd}>
                                            <form noValidate>
                                                <Droppable droppableId={"variantDragAndDrop"}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.droppableProps}
                                                            className={`content-inner ${snapshot.isDraggingOver ? "dragging-over" : ""}`}>
                                                            {
                                                                variantAllFieldsData && variantAllFieldsData.map((variantItem, variantIndex) => {
                                                                    return (
                                                                        <Draggable key={variantItem.variation_id} draggableId={variantItem.variation_id.toString()} index={variantIndex}>
                                                                            {(provided, snapshot) => (
                                                                                <div className={`frac ${snapshot.isDragging ? "dragging" : ''}`}>
                                                                                    <div
                                                                                        {...provided.draggableProps}
                                                                                        ref={provided.innerRef}
                                                                                        className={`frac-inner d-flex`}>
                                                                                        <div className="move-icon" {...provided.dragHandleProps}>
                                                                                            <FeatherIcon
                                                                                                icon="move"
                                                                                                size="20"
                                                                                                className="icon" />
                                                                                        </div>
                                                                                        <div className="d-flex flex-wrap media-body">
                                                                                            {/* item */}
                                                                                            <div className="form-item item-name">
                                                                                                {/* form field */}
                                                                                                <div className={`st-form mb-2 ${variantItem?.is_field_touched ? "touched" : ''} ${variantItem?.has_field_error ? "has-msg msg-error" : ''} ${variantItem?.is_field_touched && !variantItem.variation_name.length ? "is-empty" : ''}`}>
                                                                                                    <label className="mb-1">
                                                                                                        Name
                                                                                                        <span className="required">*</span>
                                                                                                    </label>
                                                                                                    <input
                                                                                                        placeholder="Name"
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        defaultValue={variantItem.variation_name}
                                                                                                        onChange={ev => handleNameChange(ev, variantIndex)}
                                                                                                        onFocus={ev => handleNameFocus(ev, variantIndex)}
                                                                                                        onBlur={ev => handleNameBlur(ev, variantIndex)}
                                                                                                    />
                                                                                                    {
                                                                                                        ((variantItem?.is_field_touched) && (variantItem?.has_field_error)) &&
                                                                                                        /* form message */
                                                                                                        <div className="st-form-msg position-absolute">
                                                                                                            <p className="st-fs-12">{variantItem?.error_msg ?? "some error in this field"}</p>
                                                                                                        </div>
                                                                                                    }
                                                                                                </div>

                                                                                                {/* delete item */}
                                                                                                <div className="delete-frac-item">
                                                                                                    <a href="/" className="st-text-danger st-fw-600 text-decoration-none text-danger d-flex align-items-center" onClick={ev => handleDeleteVariant(ev, variantItem.variation_id)}>
                                                                                                        <FeatherIcon
                                                                                                            icon="trash-2"
                                                                                                            size="13"
                                                                                                            className="icon me-1" />
                                                                                                        <span>Delete Option</span>
                                                                                                    </a>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* item */}
                                                                                            <div className="form-item item-type">
                                                                                                {/* form field */}
                                                                                                <div className={`st-form mb-2`}>
                                                                                                    <label className="mb-1">
                                                                                                        Option
                                                                                                        <span className="required">*</span>
                                                                                                    </label>
                                                                                                    <select
                                                                                                        className="form-control"
                                                                                                        defaultValue={variantItem.display_type}
                                                                                                        onChange={ev => handleOptionChange(ev, variantIndex)}>
                                                                                                        <option disabled>Select Type</option>
                                                                                                        <option value="radio_buttons">Radio Buttons</option>
                                                                                                        <option value="rectangle_list">Rectangle List</option>
                                                                                                        <option value="dropdown">Dropdown</option>
                                                                                                    </select>
                                                                                                    {
                                                                                                        /* form message */
                                                                                                        // <div className="st-form-msg position-absolute">
                                                                                                        //     <p className="st-fs-12">{variantErrors.name}</p>
                                                                                                        // </div>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* item */}
                                                                                            <div className="form-item item-values d-flex flex-wrap">
                                                                                                {/* all form fields */}
                                                                                                <DragDropContext onDragEnd={result => onVariantValueDragEnd(result, variantIndex)}>
                                                                                                    <Droppable droppableId={"variantDragAndDropForValue"}>
                                                                                                        {(provided, snapshot) => (
                                                                                                            <div ref={provided.innerRef}
                                                                                                                {...provided.droppableProps}
                                                                                                                className={`all-form-fields media-body ${snapshot.isDraggingOver ? "dragging-over" : ""}`}>
                                                                                                                {
                                                                                                                    (variantItem.options && variantItem.options.length) && variantItem.options.map((variantValueItem, variantValueIndex) => {
                                                                                                                        return (
                                                                                                                            // item
                                                                                                                            <Draggable key={variantValueItem.id} draggableId={variantValueItem.id.toString()} index={variantValueIndex}>
                                                                                                                                {(provided, snapshot) => (
                                                                                                                                    <div
                                                                                                                                        {...provided.draggableProps}
                                                                                                                                        ref={provided.innerRef}
                                                                                                                                        className={`form-item-outer d-flex flex-wrap ${snapshot.isDragging ? "dragging" : ''}`}>
                                                                                                                                        {/* move icon */}
                                                                                                                                        <div className="move-icon" {...provided.dragHandleProps}>
                                                                                                                                            <FeatherIcon
                                                                                                                                                icon="move"
                                                                                                                                                size="20"
                                                                                                                                                className="icon" />
                                                                                                                                        </div>

                                                                                                                                        {/* form item */}
                                                                                                                                        <div className="form-item media-body" data-key={variantValueItem.id}>
                                                                                                                                            {/* form field */}
                                                                                                                                            <div className={`st-form mb-2 ${variantValueItem?.is_field_touched ? "touched" : ''} ${variantValueItem?.has_field_error ? "has-msg msg-error" : ''} ${variantValueItem?.is_field_touched && !variantValueItem.value?.length ? "is-empty" : ''}`}>
                                                                                                                                                <label className="mb-1">
                                                                                                                                                    Value
                                                                                                                                                    <span className="required">*</span>
                                                                                                                                                </label>
                                                                                                                                                <input
                                                                                                                                                    placeholder="Name"
                                                                                                                                                    type="text"
                                                                                                                                                    className="form-control"
                                                                                                                                                    defaultValue={variantValueItem.value}
                                                                                                                                                    onChange={ev => handleValueChange(ev, variantIndex, variantValueIndex)}
                                                                                                                                                    onFocus={ev => handleValueFocus(ev, variantIndex, variantValueIndex)}
                                                                                                                                                    onBlur={ev => handleValueBlur(ev, variantIndex, variantValueIndex)}
                                                                                                                                                />
                                                                                                                                                {
                                                                                                                                                    ((variantValueItem?.is_field_touched) && (variantValueItem?.has_field_error)) &&
                                                                                                                                                    /* form message */
                                                                                                                                                    <div className="st-form-msg position-absolute">
                                                                                                                                                        <p className="st-fs-12">{variantValueItem?.error_msg ?? "some error in this field"}</p>
                                                                                                                                                    </div>
                                                                                                                                                }
                                                                                                                                            </div>

                                                                                                                                            {/* delete item */}
                                                                                                                                            <div className="delete-frac-item mb-2">
                                                                                                                                                <a href="/" className="st-text-danger st-fw-600 text-decoration-none text-danger d-flex align-items-center" onClick={ev => handleDeleteVariantValue(ev, variantIndex, variantItem.variation_id, variantValueItem.id, variantItem.variation_name, variantValueItem.value)}>
                                                                                                                                                    <FeatherIcon
                                                                                                                                                        icon="trash-2"
                                                                                                                                                        size="13"
                                                                                                                                                        className="icon me-1" />
                                                                                                                                                    <span>Delete Value</span>
                                                                                                                                                </a>
                                                                                                                                            </div>
                                                                                                                                        </div>

                                                                                                                                        {/* make default */}
                                                                                                                                        <div className="select-default ps-2">
                                                                                                                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                                                                                                                <input
                                                                                                                                                    type="radio"
                                                                                                                                                    className="d-none"
                                                                                                                                                    name={`${variantIndex}_${variantValueIndex}_isDefault`}
                                                                                                                                                    checked={variantValueItem.is_default ? true : false}
                                                                                                                                                    onChange={ev => handleIsDefaultChange(ev, variantIndex, variantValueIndex)} />
                                                                                                                                                <span className="box d-flex align-items-center justify-content-center border">
                                                                                                                                                    <FeatherIcon
                                                                                                                                                        icon="check"
                                                                                                                                                        size="15"
                                                                                                                                                        className="icon position-relative" />
                                                                                                                                                </span>
                                                                                                                                                <span className="text text-capitalize st-fs-15 ms-2">default</span>
                                                                                                                                            </label>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                )}
                                                                                                                            </Draggable>
                                                                                                                        )
                                                                                                                    })
                                                                                                                }
                                                                                                                {/* placeholder for droppable for values */}
                                                                                                                {provided.placeholder}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </Droppable>
                                                                                                </DragDropContext>

                                                                                                {/* radio */}
                                                                                                <div className="add-field w-100 mt-2">
                                                                                                    <p
                                                                                                        className="d-inline-flex align-items-center st-text-primary cursor-pointer"
                                                                                                        onClick={(ev) => handleAddVariantValue(ev, variantIndex)}>
                                                                                                        <FeatherIcon
                                                                                                            icon="plus"
                                                                                                            size="15"
                                                                                                            className="icon me-1"
                                                                                                        />
                                                                                                        <span>Add another field</span>
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    )
                                                                })
                                                            }

                                                            {/* placeholder for droppable for main variant */}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            </form>
                                        </DragDropContext>

                                        {
                                            !variantAllFieldsData?.length ? (
                                                <p className="text-center my-2 st-text-color2">
                                                    Click the <span className="st-fw-600">Add Option</span> button to add a variant
                                                </p>
                                            ) : null
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* buttons */}
                            <div className="btns d-flex mt-3">
                                <button
                                    className="btn st-btn st-btn-sm st-btn-primary-outlined text-capitalize st-fw-400 d-flex align-items-center me-3"
                                    onClick={handleAddVariant}>
                                    <FeatherIcon
                                        icon="plus"
                                        size="15"
                                        className="icon me-2" />
                                    <span>add option</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>

            {/* modals */}
            <InfoModal
                modalType={"modal_confirm"} // required: type of the modal: modal_confirm && modal_info.
                modalVisibility={leavethePageModalVisibility} // required: determine modal visibility either true or false
                onHide={onLeavePageModalHide} // required to hide the modal

                modalTitle={"Are you sure you want to leave this page?"} // required: show the title
                modalDescription={"You have unsaved changes. All your changes will be lost"} // shows the description

                confirmBtnText={"Stay on the page"} // works only if the modalType is modal_confirm: text for confirm btn. default is "Confirm Action"
                cancelBtnText={"Leave the page"} // works only if the modalType is modal_confirm: text for cancel btn. default is "Confirm Action"
                confirmAction={bool => confirmPageLeaveAction(bool)}
            />

            <InfoModal
                modalType={"modal_confirm"} // required: type of the modal: modal_confirm && modal_info.
                modalVisibility={changingTheVariantModalVisibility} // required: determine modal visibility either true or false
                onHide={onConfirmChangingVariantModalHide} // required to hide the modal

                modalTitle={"Are you sure you want to continue?"} // required: show the title
                modalDescription={"You are making the changes that will cause the variants data to be generated from the begning"} // shows the description

                confirmBtnText={"Keep Existing Data"} // works only if the modalType is modal_confirm: text for confirm btn. default is "Confirm Action"
                cancelBtnText={"Create variants anyway"} // works only if the modalType is modal_confirm: text for cancel btn. default is "Confirm Action"
                confirmAction={bool => confirmChangingVariantAction(bool)}
            />
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddVariation)